
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bris",
      function () {
        return require("private-next-pages/bris.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bris"])
      });
    }
  